/* import __COLOCATED_TEMPLATE__ from './sq-custom-report-print-table.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { classNames, tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
function indentationSpaces(indentation) {
  return htmlSafe('&emsp;'.repeat(indentation));
}

/**
## Sq Custom Report Print Table

Takes the same columns and content as sq-super-table, but displays the table in a printer-friendly manner.
It will only be shown while the page is being printed.

### Example

```handlebars

{{sq-custom-report-print-table content=content
                               columns=columns}}
```

### Example

```handlebars

{{#sq-custom-report-print-table content=content
                                columns=columns as |row column|}}
    <strong>{{get row column.cellContentProperty}}</strong>
{{/sq-custom-report-print-table}}

```

### Parameters
@param {Column[]} columns - The columns for the table, as defined in sq-super-table
@param {CustomReportTableRow[]} content - The content for the rows of the table, as defined in sq-super-table
@param {Boolean} [hasFooter=true] - If true, a footer will be displayed.
*/
let SqCustomReportPrintTable = (_dec = classNames('show-when-print', 'l-reports--table'), _dec2 = tagName('table'), _dec3 = computed('content.@each.{isNested,indentation}', 'columns.@each.{cellContentFunction,cellContentProperty,typeAlign}'), _dec4 = computed('columns.@each.{headerCellTitle,typeAlign}'), _dec5 = computed('columns.@each.{footerValue,typeAlign}'), _dec(_class = _dec2(_class = (_class2 = class SqCustomReportPrintTable extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, 'data-test-custom-report-print-table', true);
    _defineProperty(this, "columns", null);
    _defineProperty(this, "content", null);
    _defineProperty(this, "hasFooter", true);
  }
  get rows() {
    return this.content.map(row => {
      return {
        rowClass: row.get('isNested') ? 'super-table-row--is-nested' : undefined,
        cells: this.columns.map((column, index) => {
          return {
            indent: index === 0 ? indentationSpaces(row.get('indentation')) : '',
            value: column.getCellContent(row),
            columnClass: column.get('typeAlign'),
            row,
            column
          };
        })
      };
    });
  }
  get headers() {
    return this.columns.map(column => {
      return {
        name: column.get('headerCellTitle'),
        columnClass: column.get('typeAlign')
      };
    });
  }
  get footerCells() {
    return this.columns.map(column => {
      return {
        value: column.get('footerValue'),
        columnClass: column.get('typeAlign')
      };
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "rows", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "rows"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "headers", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "headers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "footerCells", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "footerCells"), _class2.prototype), _class2)) || _class) || _class);
export { SqCustomReportPrintTable as default };